<template>
  <div :id="uid" class="zt-accordion-item w-full rounded" :class="activeClassPanel" v-show="visible">
    <div
      class="selected-disabled zt-accordion-item--header p-custom flex h-24 w-full cursor-pointer items-center justify-between"
      :class="classes" @click="_onClick">
      <h2 class="text-zt-lg">
        <zt-icon :name="prependIcon" v-if="prependIcon !== ''" class="prepend-icon mr-4" />
        <span>{{ title }}</span>
      </h2>
      <zt-icon :name="iconName" class="bold text-zt-xl" />
    </div>
    <Transition :css="false" name="accordion" @enter="start" @after-enter="end" @before-leave="start"
      @after-leave="end">
      <div v-show="isActiveContent" class="zt-accordion-item--content w-full">
        <div class="p-4">
          <slot />
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: 'ztAccordionItem',
  inheritAttrs: false,
}
</script>


